import {getPrimitive} from '@tickchak/react-share/app';
import {CircularProgressbarWithChildren, buildStyles} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import * as css from './PlanImage.css';

interface PlanImageProps {
    image?: string;
    realizationPercentage: number;
    onEditClick?: (e: React.MouseEvent) => void;
    variant?: 'row' | 'card';
}

function PlanImage({image, realizationPercentage, onEditClick, variant = 'row'}: PlanImageProps) {
    return (
        <css.imageContainer variant={variant}>
            <css.seriesImage image={image} />
            <css.progressContainer>
                <css.progress className='progress'>
                    <CircularProgressbarWithChildren
                        value={realizationPercentage}
                        styles={buildStyles({
                            rotation: 0.25,
                            pathColor: getPrimitive('oranges.orange400'),
                            trailColor: getPrimitive('solids.white')
                        })}
                    >
                        <css.percentageValue>
                            {realizationPercentage}%
                        </css.percentageValue>
                    </CircularProgressbarWithChildren>
                </css.progress>
                <css.editIcon 
                    className='editIcon' 
                    onClick={(e) => {
                        e.stopPropagation();
                        onEditClick?.(e);
                    }} 
                />
            </css.progressContainer>
        </css.imageContainer>
    );
}

export default PlanImage;

